export const mergeDeckAndSettingsData = (slideDeck, settingsData) => {
  return {
    ...slideDeck,
    name: settingsData.deckName || slideDeck.name,
    slides: mergeSlidesAndSettingsData(slideDeck.slides, settingsData),
    themeData: {
      ...slideDeck.themeData,
      ...settingsData.themeData
    },
    eventSettings: {
      ...slideDeck.eventSettings,
      ...settingsData.eventSettings
    },
    metaData: {
      ...slideDeck.metaData,
      ...settingsData.metaData
    }
  }
}

export const mergeSlidesAndSettingsData = (slides, settingsData) => {
  return (slides || []).map((slide, index) => {
    return {
      ...slide,
      content: {
        ...slide.content,
        title: !index && slide.template === 'joinSlide' ? settingsData.joinSlideTitle : slide.content.title
      }
    }
  })
}
